import { useQuery } from "react-query";
import { getTimezones } from "services/timezones";
import { useContextService } from "./use-context-service";

export const useTimezones = () =>
  useQuery("timezones", useContextService(getTimezones));
